"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ChildrenAges = ChildrenAges;
exports.CollegeTerm = CollegeTerm;
exports.ContributionPercent = ContributionPercent;
exports.NumberOfChildren = NumberOfChildren;
exports.Savings = Savings;
var _react = _interopRequireWildcard(require("react"));
var _DropdownForNatLangForm = require("../Wizard/DropdownForNatLangForm");
var _TextInputForNatLangForm = require("../Wizard/TextInputForNatLangForm");
var _reactBootstrap = require("react-bootstrap");
var _formikMiddleware = _interopRequireDefault(require("../../middleware/formikMiddleware"));
var _formik = require("formik");
var _CollegeSavingsWizardCalc = require("./CollegeSavingsWizardCalc.config");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function NumberOfChildren(_ref) {
  var {
    setFieldValue,
    values
  } = _ref;
  var fieldName = 'numOfKids';
  var preText = 'I have ';
  var postText = ' ';
  return /*#__PURE__*/_react.default.createElement(_DropdownForNatLangForm.DropdownForNatLangForm, {
    values: values,
    dropdownArray: _CollegeSavingsWizardCalc.dropdownOptions.numOfKidsArray,
    fieldName: fieldName,
    preText: preText,
    setFieldValue: setFieldValue,
    postText: postText,
    calcName: _CollegeSavingsWizardCalc.calcName,
    id: _CollegeSavingsWizardCalc.idPrefix + fieldName
  });
}
function ChildrenAges(_ref2) {
  var {
    errors,
    touched,
    values,
    setFieldValue,
    setFieldTouched
  } = _ref2;
  var {
    numOfKids
  } = values;
  var multipleChildrenInd = numOfKids > 1 ? true : false;

  /**
   * This useEffect is used to manipulate the formik 'values' and 'touched' objects
   * As a user changes the numOfKids dropdown, we want to clean up formik to represent the state changes
   * For instance, if a user changes from 2 kids to 1 kids. We need to go into 'values' object and clean up the 2nd element
   * which represented the second child, we also want to make sure the 'touched' object does not think we have touched the 2nd child age field
   *
   */
  (0, _react.useEffect)(() => {
    var childrenArrayValues = [];
    var childrenArrayTouched = [];
    for (var i = 0; i < 10; i++) {
      var _touched$children;
      // we start with an empty childrenArrayValues object and only push valid child objects
      // a valid child object is a child object for a child that the user is claiming
      // so if I have said I have 3 kids and then changed to 2, formik still has data for 3rd kid that the user
      // previously entered, we will drop that child object
      if (i + 1 <= numOfKids && values.children[i]) {
        childrenArrayValues.push(values.children[i]);
      } else if (i + 1 <= numOfKids && !values.children[i]) {
        childrenArrayValues.push({
          childAge: ''
        });
      }
      // If i >= numOfKids and there is an element at touched[i], then remove it
      // as we want to clean up the touched object to remove elements that don't exist
      if (i + 1 <= numOfKids && touched !== null && touched !== void 0 && (_touched$children = touched.children) !== null && _touched$children !== void 0 && _touched$children[i]) {
        childrenArrayTouched[i] = touched.children[i];
      }
    }
    setFieldValue('children', childrenArrayValues);
    setFieldTouched('children', childrenArrayTouched);
  }, [numOfKids]);
  return /*#__PURE__*/_react.default.createElement(_formik.FieldArray, {
    name: "children"
  }, fieldArrayProps => {
    var {
      form
    } = fieldArrayProps;
    var {
      values
    } = form;
    var {
      children,
      numOfKids
    } = values;
    var returnArray = children.map((child, i) => {
      var firstChildInd = i == 0 ? true : false;
      var lastChildInd = i + 1 == numOfKids;
      var labelText;
      if (!multipleChildrenInd) {
        labelText = 'child who is ';
      } else if (firstChildInd) {
        labelText = 'children who are ';
      } else {
        labelText = 'and ';
      }
      return /*#__PURE__*/_react.default.createElement(ChildAge, {
        key: i,
        errors: errors,
        touched: touched,
        values: values,
        i: i,
        lastChildInd: lastChildInd,
        labelText: labelText
      });
    });
    return returnArray;
  });
}
function ChildAge(props) {
  var _errors$children, _touched$children2, _errors$children2;
  var {
    errors,
    touched,
    lastChildInd,
    labelText,
    i
  } = props;
  return /*#__PURE__*/_react.default.createElement(_react.Fragment, {
    key: "childAge".concat(i)
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Label, {
    htmlFor: "childAge".concat(i)
  }, labelText), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Group, {
    key: "childAge".concat(i)
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.InputGroup, {
    className: "".concat((errors === null || errors === void 0 || (_errors$children = errors.children) === null || _errors$children === void 0 || (_errors$children = _errors$children[i]) === null || _errors$children === void 0 ? void 0 : _errors$children.childAge) && (touched === null || touched === void 0 || (_touched$children2 = touched.children) === null || _touched$children2 === void 0 || (_touched$children2 = _touched$children2[i]) === null || _touched$children2 === void 0 ? void 0 : _touched$children2.childAge) && 'is-invalid')
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Control, {
    id: "childAge".concat(i),
    "aria-label": "childAge".concat(i),
    placeholder: "00",
    as: "input",
    maxLength: 3,
    htmlSize: 3,
    type: "text",
    name: "children[".concat(i, "].childAge"),
    value: props.values.children[i].childAge,
    onChange: (0, _formikMiddleware.default)().digitFilterChainHandler({
      removeLeadingZeroes: true
    }).handleChange(),
    onBlur: (0, _formikMiddleware.default)().tealium(_CollegeSavingsWizardCalc.calcName, "childAge".concat(i)).handleBlur()
  })), /*#__PURE__*/_react.default.createElement(_reactBootstrap.FormControl.Feedback, {
    type: "invalid",
    className: "custom-feedback",
    tooltip: true
  }, errors === null || errors === void 0 || (_errors$children2 = errors.children) === null || _errors$children2 === void 0 || (_errors$children2 = _errors$children2[i]) === null || _errors$children2 === void 0 ? void 0 : _errors$children2.childAge)), "\xA0years old", lastChildInd ? '.' : '', "\xA0");
}
function CollegeTerm(_ref3) {
  var {
    values,
    setFieldValue
  } = _ref3;
  var fieldName = 'collegeTerm';
  var {
    numOfKids
  } = values;
  var labelText = numOfKids > 1 ? " of my children's " : " of my child's ";
  var preText = labelText;
  var postText = ' college expenses. ';
  return /*#__PURE__*/_react.default.createElement(_DropdownForNatLangForm.DropdownForNatLangForm, {
    values: values,
    id: _CollegeSavingsWizardCalc.idPrefix + fieldName,
    dropdownArray: _CollegeSavingsWizardCalc.dropdownOptions.collegeTermArray,
    fieldName: fieldName,
    preText: preText,
    setFieldValue: setFieldValue,
    postText: postText,
    calcName: _CollegeSavingsWizardCalc.calcName
  });
}
function ContributionPercent(_ref4) {
  var {
    errors,
    touched,
    values
  } = _ref4;
  var fieldName = 'contributionPercent';
  var type = 'text';
  var inputMode = 'numeric';
  var maxLength = '5';
  var placeholder = '100';
  var preText = 'I plan to fund ';
  var postText = ' ';
  var htmlSize = 4;
  function generateOnChange() {
    return (0, _formikMiddleware.default)().digitFilterChainHandler({
      removeLeadingZeroes: false,
      currencyInput: false,
      zeroAlways: false,
      allowDecimals: 2
    }).handleChange();
  }
  function generateOnBlur() {
    return (0, _formikMiddleware.default)().tealium(_CollegeSavingsWizardCalc.calcName, fieldName).handleBlur();
  }
  return /*#__PURE__*/_react.default.createElement(_TextInputForNatLangForm.TextInputForNatLangForm, {
    fieldName: fieldName,
    htmlSize: htmlSize,
    preText: preText,
    postText: postText,
    errors: errors,
    touched: touched,
    id: _CollegeSavingsWizardCalc.idPrefix + fieldName,
    values: values,
    type: type,
    inputMode: inputMode,
    maxLength: maxLength,
    placeholder: placeholder,
    prepend: false,
    append: true,
    onChange: generateOnChange(),
    onBlur: generateOnBlur()
  });
}
function Savings(_ref5) {
  var {
    errors,
    touched,
    values,
    setFieldValue
  } = _ref5;
  var {
    numOfKids
  } = values;
  var labelText = numOfKids > 1 ? " saved in my children's college fund." : " saved in my child's college fund.";
  var postText = labelText;
  var preText = 'I have ';
  var fieldName = 'savings';
  var inputMode = 'numeric';
  var maxLength = '10';
  var placeholder = '0';
  var htmlSize = '10';
  var type = 'text';
  function generateOnChange() {
    return (0, _formikMiddleware.default)().digitFilterChainHandler({
      removeLeadingZeroes: true,
      currencyInput: true,
      zeroAlways: false
    }).handleChange();
  }
  function generateOnBlur() {
    return (0, _formikMiddleware.default)().tealium(_CollegeSavingsWizardCalc.calcName, fieldName).handleBlur();
  }
  return /*#__PURE__*/_react.default.createElement(_TextInputForNatLangForm.TextInputForNatLangForm, {
    preText: preText,
    postText: postText,
    htmlSize: htmlSize,
    fieldName: fieldName,
    id: _CollegeSavingsWizardCalc.idPrefix + fieldName,
    errors: errors,
    touched: touched,
    values: values,
    setFieldValue: setFieldValue,
    type: type,
    inputMode: inputMode,
    maxLength: maxLength,
    placeholder: placeholder,
    prepend: true,
    append: false,
    onChange: generateOnChange(),
    onBlur: generateOnBlur()
  });
}